import { SR_API_ACTION_UTILITY_ACTIVATION_GET } from 'api/utilityActionTypes';

export default async function getByShortId(
  { state, utilityApiClient },
  { utilityActivationShortId, forceRefresh = false },
) {
  const statePath = ['utilityActivations', 'byShortId', utilityActivationShortId];
  if (state.get(statePath) && !forceRefresh) {
    return state.get(statePath);
  }

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_ACTIVATION_GET,
    state: state,
    queryId: utilityActivationShortId,
    payload: {
      shortId: utilityActivationShortId,
    },
    onSuccess(utilityActivation) {
      state.set(statePath, utilityActivation);
    },
  });
}
